
import './App.css';
import ChatBotFile from './chatbotFile/ChatBotFile';

import { BrowserRouter as Router } from "react-router-dom";
function App() {
  return (
    <div className="App">
      <ChatBotFile/>
    </div>
  );
}

export default App;
